<div class="card-item-snake-top-arrow"></div>
<div class="card-item-snake-top-info-box">
  @if (card().completed) {
    <div class="completed-box">
      <ptl-icon [icon]="Tick01Icon"></ptl-icon>
    </div>
  } @else if (card().started) {
    <div class="started-box"></div>
  } @else {
    <div class="not-started-box"></div>
  }
</div>

<div
  class="card-item-main"
  [class.completed]="card().completed"
  (click)="cardClick.emit(card())"
  (keydown.enter)="cardClick.emit(card())"
  tabindex="0"
  role="button"
  [attr.aria-label]="'Open ' + card().header"
>
  <div class="card-item-main-inner">
    <div class="card-item-main-image">
      <div *ngIf="card().image" class="card-item-main-image-content">
        <img [src]="card().image" [alt]="card().header" />
      </div>
      <div *ngIf="!card().image" class="card-item-main-image-placeholder">
        <img src="assets/collections/collector-card-placeholder.png" [alt]="card().header" />
      </div>

      <div *ngIf="card().completed" class="card-item-main-completion-indicator">
        <mat-icon>check_circle</mat-icon>
      </div>
    </div>

    <div class="card-item-main-content">
      <div class="card-item-main-type-badge" *ngIf="card().collectionType">{{ card().collectionType }}</div>
      <h3 class="card-item-main-title">{{ card().header }}</h3>
      <p *ngIf="card().subHeader" class="card-item-main-subtitle">{{ card().subHeader }}</p>
    </div>
  </div>
</div>
